import React, { useEffect, useState } from 'react';
import { formatISO } from 'date-fns';
import AppUnit from './AppUnit';
import Period from './period';
import PeriodSelection from './PeriodSelection';
import Skeleton from '../../../Utilities/Skeleton';
import { post } from '../../Auths/AuthToken';
import PrintSchedulePopup from './PrintSchedulePopup';
import ReactDOMServer from 'react-dom/server';
import setUiMessage from '../../../Utilities/Tostify';
import { useDispatch, useSelector } from 'react-redux';
import {
  setAppPerriodFilter,
  updateSearchParams,
} from '../../../redux/slices/scheduler/appointmentSlice';
import { formatDateSafely } from '../../../Utilities/Utilities';

function Appoinments({ tabType = 0 }) {
  const dispatch = useDispatch();
  const { user } = useSelector((store) => store.auth);
  const { appPeriodFilter, appSearchPrams } = useSelector(
    (store) => store.appointment
  );

  const { globalReload } = useSelector((store) => store.app);
  const [allData, setAllData] = useState(null);
  const [appData, setAppData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [reloadComponent, setReloadComponent] = useState(false);
  const [appSelectedId, setAppSelectedId] = useState('');

  useEffect(() => {
    if (!appPeriodFilter.startDate) {
      dispatch(
        setAppPerriodFilter({
          name: 'day',
          startDate: formatISO(new Date()),
          endDate: formatISO(new Date()),
        })
      );
      return;
    }

    if (appPeriodFilter.startDate) {
      (async (prams) => {
        try {
          setIsLoading(true);
          const response = await post('api/auth/getapplist', prams);
          if (response.status === 200) {
            setAllData(response?.data);
            setAppData(response?.data?.allAppointmentList);
            setIsLoading(false);
          }
        } catch (err) {
          setUiMessage('err', err.message);
        }
      })({
        appointmentDate: `${formatDateSafely(
          appPeriodFilter.startDate,
          'yyyy-MM-dd'
        )}|${formatDateSafely(appPeriodFilter.endDate, 'yyyy-MM-dd')}`,
        allProviders: appSearchPrams.allProviders,
        searchNameString: appSearchPrams.searchNameString,
        searchContactString: appSearchPrams.searchContactString,
        showAutoMaticOnPageLoad: appSearchPrams.showAutoMaticOnPageLoad,
        sortOrder: appSearchPrams.sortOrder,
        clinicLocation: appSearchPrams.clinicLocation,
        tov: appSearchPrams.tov,
        actStatus: appSearchPrams.actStatus,
        payor: appSearchPrams.payor,
        dayType: appPeriodFilter.name,
        staffUserId: user?.id,
        tabType: tabType,
        reminderStatus: appSearchPrams?.reminderStatus,
      });
    }
  }, [
    appSearchPrams,
    appPeriodFilter,
    reloadComponent,
    globalReload,
    user,
    tabType,
  ]);

  useEffect(() => {
    if (tabType === '1') {
      dispatch(updateSearchParams({ key: 'actStatus', value: '' }));
    }
  }, [dispatch, tabType]);

  const handleReload = () => {
    setReloadComponent(!reloadComponent);
  };

  function handleLocation(e) {
    dispatch(
      updateSearchParams({ key: 'clinicLocation', value: e.target.value })
    );
  }

  const handlePrintSchedule = async () => {
    const newWindow = window.open('', '_blank', 'height=700,width=900');
    if (newWindow) {
      const htmlString = ReactDOMServer.renderToString(
        <PrintSchedulePopup datas={appData} apptDate={allData} />
      );
      newWindow.document.write(htmlString);
      newWindow.document.close();
      if (newWindow) {
        newWindow.print();
      }
    } else {
      setUiMessage(
        'war',
        'Popup blocked! Please allow popups for this website.'
      );
    }
  };

  function handleNameSearch(e) {
    dispatch(
      updateSearchParams({
        key: 'searchNameString',
        value: e.target.value || '',
      })
    );
  }
  function handleContactSearch(e) {
    dispatch(
      updateSearchParams({
        key: 'searchContactString',
        value: e.target.value || '',
      })
    );
  }

  function handleAllTovs(e) {
    dispatch(
      updateSearchParams({
        key: 'tov',
        value: e.target.value || '',
      })
    );
  }

  function handleAllRemider(e) {
    dispatch(
      updateSearchParams({
        key: 'reminderStatus',
        value: e.target.value || '',
      })
    );
  }

  function handleAllStatus(e) {
    dispatch(
      updateSearchParams({
        key: 'actStatus',
        value: e.target.value || '',
      })
    );
  }

  function handlePayor(e) {
    dispatch(
      updateSearchParams({
        key: 'payor',
        value: e.target.value || '',
      })
    );
  }

  function handleAllProviders(e) {
    dispatch(
      updateSearchParams({
        key: 'allProviders',
        value: e.target.value,
      })
    );
  }

  return (
    <main>
      <section>
        <div className="child-menu-body">
          <div className="child-body-rw appt-sec-fst-rw">
            <div className="appt-d-display">
              {appPeriodFilter?.startDate ? (
                <>
                  <Period
                    periodFilter={appPeriodFilter}
                    setPeriodFilter={(obj) => dispatch(setAppPerriodFilter(obj))}
                  />
                  <PeriodSelection
                    selectedPeriod={appPeriodFilter}
                    setPeriodFilter={(obj) => dispatch(setAppPerriodFilter(obj))}
                  />
                </>
              ) : null}
            </div>
            <div className="appt-awt-col">
              {appPeriodFilter.name === 'day' &&
              Date.parse(
                formatDateSafely(appPeriodFilter.startDate, 'yyyy-MM-dd')
              ) === Date.parse(formatDateSafely(new Date(), 'yyyy-MM-dd')) ? (
                <>
                  <span className="appt-awt-label">Avg waiting time</span>
                  <span className="appt-awt-val">
                    {allData?.averageWaitingTime}
                  </span>
                </>
              ) : (
                ''
              )}
            </div>
            <div className="appt-sumary">
              <span className="first">
                Scheduled
                <br />
                <b>{allData?.numallAppointmentList}</b>
              </span>
              <span className="sec">
                No show/ Canceled/ Resch.
                <br />
                <b>{allData?.sumryCount}</b>
              </span>
              <span className="third">
                Visited
                <br />
                <b>{allData?.visited}</b>
              </span>
            </div>
            <div className="appt-search">
              <span className="appt-loc-val">
                <span className="prnt-btn" onClick={handlePrintSchedule}>
                  Print Schedule
                </span>
              </span>
              <span className="appt-loc-val">
                <select
                  className="appt-col-slct"
                  value={appSearchPrams.clinicLocation}
                  onChange={handleLocation}
                >
                  <option value="">All Locations</option>
                  {allData?.allLocation &&
                    allData?.allLocation.map((data, i) => {
                      return (
                        <option key={i} value={data.id}>
                          {data.location_code}
                        </option>
                      );
                    })}
                </select>
              </span>
            </div>
          </div>
          <div className="appt-body-hdr">
            <div className="appt-body-hdr-fltr-rw">
              <span className="appt-col col-0">&nbsp;</span>
              {/* <span className="appt-col col-1">&nbsp;</span> */}
              <span className="appt-col col-1">
                <select
                  className="appt-col-slct"
                  value={appSearchPrams?.reminderStatus}
                  onChange={handleAllRemider}
                >
                  {/* <option value="">All REMs</option> */}
                  {allData?.reminderStatus &&
                    allData?.reminderStatus.map((data, i) => {
                      return (
                        <option key={i} value={data.id}>
                          {data.val}
                        </option>
                      );
                    })}
                </select>
              </span>
              <span className="appt-col col-2">
                <input
                  type="search"
                  className="main-search"
                  placeholder="Search Patient..."
                  value={appSearchPrams.searchNameString}
                  onChange={handleNameSearch}
                />
              </span>
              <span className="appt-col col-3">
                <input
                  type="search"
                  className="main-search"
                  placeholder="Search Contact..."
                  value={appSearchPrams.searchContactString}
                  onChange={handleContactSearch}
                />
              </span>
              <span className="appt-col col-8">
                <select
                  className="appt-col-slct"
                  value={appSearchPrams?.payor}
                  onChange={handlePayor}
                >
                  <option value="">All Payors</option>
                  {allData?.allPayor &&
                    allData?.allPayor.map((data, i) => {
                      return (
                        <option key={i} value={data.id}>
                          {data.insurance_company_name}
                        </option>
                      );
                    })}
                </select>
              </span>
              <span className="appt-col col-7">
                <select
                  className="appt-col-slct"
                  value={appSearchPrams?.tov}
                  onChange={handleAllTovs}
                >
                  <option value="">All TOVs</option>
                  {allData?.allTov &&
                    allData?.allTov.map((data, i) => {
                      return (
                        <option key={i} value={data.id}>
                          {data.visit_type}
                        </option>
                      );
                    })}
                </select>
              </span>
              <span className="appt-col col-4">
                <select
                  className="appt-col-slct"
                  value={appSearchPrams?.allProviders}
                  onChange={handleAllProviders}
                  disabled={allData?.providerType === 1 ? 'disabled' : ''}
                >
                  <option value="">All Resource</option>
                  {allData?.allResource &&
                    allData?.allResource.map((data, i) => {
                      return (
                        <option key={i} value={data.id}>
                          {`${data.first_name} ${data.last_name} ${
                            data?.degree ? ',' : ''
                          } ${data.degree}`}
                        </option>
                      );
                    })}
                </select>
              </span>

              <span className="appt-col col-6">Appt. Date/ Status</span>

              <span className="appt-col col-10">
                <select
                  className="appt-col-slct"
                  value={appSearchPrams?.actStatus}
                  onChange={handleAllStatus}
                >
                  <option value="">All status</option>
                  {allData?.allStatusList &&
                    allData?.allStatusList.map((data, i) => {
                      return (
                        <option
                          key={i}
                          value={`${data.id}_${data.createVYesNo}_${data.treatmentVisit}`}
                        >
                          {data.status_name}
                        </option>
                      );
                    })}
                </select>
              </span>
            </div>
          </div>
          <div className="appt-body-main">
            {isLoading ? (
              <Skeleton />
            ) : appData && appData.length > 0 ? (
              appData.map((item, i) => {
                const altClas = i % 2 !== 0 ? 'alt-rw' : '';
                return (
                  <AppUnit
                    key={i}
                    item={item}
                    altClas={altClas}
                    handleReload={handleReload}
                    appSelectedId={appSelectedId}
                    setAppSelectedId={setAppSelectedId}
                  />
                );
              })
            ) : (
              <div className="no-appoinmnts-here"> No appointments found!</div>
            )}
          </div>
        </div>
      </section>
    </main>
  );
}

export default Appoinments;
